export default __webpack_public_path__ + "129e6055c167f38358ad95833f60c7a9.svg";